module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/faqs/faq.component.scss
// module id = ./src/app/faqs/faq.component.scss
// module chunks = main